import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


const featureImages = [
  
    { src: "/assets/1.png", text: "📌 Visualized Learning Path Between Books" },
    { src: "/assets/2.png", text: "💡 User-Generated Learning Paths" },
    { src: "/assets/3.png", text: "🌟 Save & Create Personalized Booklists" },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="section">
      <h2>Key Features of FlowRead</h2>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        className="feature-swiper"
      >
        {featureImages.map((item, index) => (
          <SwiperSlide key={index} className="feature-card">
            <img src={item.src} alt={`Feature ${index + 1}`} className="feature-image" />
            <p className="feature-text">{item.text}</p>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default FeaturesSection;
